import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe } from '@angular/common';
export class ServicesPGBindStore {
    constructor(
    ) {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        let request = JSON.parse(webcontext.RequestBody);
        if(request["a_EntryDate"]){
            request["a_EntryDate"] = request["a_EntryDate"].replace("T"," ");
        }
        let _arr = [request];
        // console.log(request);
        // webcontext.ResponseMessage.ErrorMessage ="结束时间不能为空";
        // webcontext.ResponseMessage.Success = false;
        webcontext.RequestBody = JSON.stringify(_arr);
        

        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        const that = this;
        if (webParameterContext.ConfigType.toLowerCase() == "form") {
            // if (webContext.ResponseMessage.Success) {
            //     if (webContext.Other) {
            //         webContext.Other.Success = true;
            //         webContext.url = "/login";
            //     } else {
            //         webContext.Other = { "Success": true, "url": "/login" };
            //     }
            // }

            // webContext.ResponseMessage.ErrorMessage="排版成功,请尽快联系上级领导审批通过后方可进入此系统";
            // webContext.ResponseMessage.Success=false;
        }
        return webContext
    }
}